import axios from "axios";

export const checkIfValidDate = (item) => {
  if (!!item?.["date Start"] && !!item?.["date End"]) {
    const dateFrom = new Date(item?.["date Start"]);
    const dateTo = new Date(item?.["date End"]);
    const dateCheck = new Date();
    dateCheck.setHours(0);
    dateCheck.setMinutes(0);
    dateCheck.setSeconds(0);
    dateCheck.setMilliseconds(0);
    return (
      dateCheck.getTime() >= dateFrom.getTime() &&
      dateCheck.getTime() <= dateTo.getTime()
    );
  }
};
const generateLink = async (link) => {
  let newLink = "";
  const res = await axios(
    `${process.env.REACT_APP_API_ENDPOINT}/taobao_generatorPromoLink`,
    {
      params: {
        promotion_link_type: 0,
        source_values: link,
      },
    }
  );

  newLink =
    res?.data?.resp_result?.result?.promotion_links?.promotion_link[0]
      ?.promotion_link;
  return newLink;
};

export const replaceItemsLink = async (originalLink) => {
  // console.log("originalLink", originalLink);
  let link = await generateLink(originalLink);
  return link;
};

export const categoriesTypes = [
  "Food",
  "Meat",
  "Fruits and Berries",
  "Bread and Pastries",
  "Canned Food",
  "Sausages",
  "Canned Food1",
  "Alcoholic Beverages",
  "Fish and Sea Food",
  "Grocery",
  "Nut &amp; Kernel1",
  "Dried Fruit1",
  "Grain Products1",
  "Coffee1",
  "Milk and Eggs",
  "Ready Meal",
  "Water/ Juices/ Drinks",
  "Dried Goods / Local Specialties",
  "Coffee",
  "Dried Goods / Local Specialties1",
  "Cheese",
  "Dried Fruit",
  "Grain Products",
  "Nut &amp; Kernel",
  "Frozen Products",
  "Tea",
  "Vegetables and Greens",
  "Apparel &amp; Accessories",
  "Sportswears",
  "Home Appliances",
  "Other Home Appliances",
  "Personal Care Appliances",
  "Commercial Appliances",
  "Cleaning Appliances",
  "Home Appliance Parts",
  "Kitchen Appliances",
  "Major Appliances",
  "Household Appliances",
  "Computer &amp; Office",
  "Desktops &amp; AIO",
  "Laptops",
  "Laptop Parts &amp; Accessories",
  "Computer Peripherals",
  "Tablets",
  "Tablet Accessories &amp; Parts",
  "Computer Components",
  "Storage Device",
  "Networking",
  "Computer Cleaners",
  "Office Software",
  "Internal Storage",
  "Barebone &amp; Mini PC",
  "3D Printing &amp; Additive Manufacturing",
  "Office Electronics",
  "Servers &amp; Industrial Computer",
  "DIY Gaming Computer",
  "Home Improvement",
  "Electrical Equipment &amp; Supplies",
  "Hardware",
  "Stone Carvings and Sculptures",
  "Landscaping Stone",
  "Countertops,Vanity Tops &amp; Table Tops",
  "Painting Supplies &amp; Wall Treatments",
  "Functional Material",
  "Quarry Stone &amp; Slabs",
  "Building Glass",
  "Ladders &amp; Scaffoldings",
  "Other Home Improvement",
  "Metal Building Materials",
  "Bathroom Fixture",
  "Kitchen Fixture",
  "Heating, Cooling &amp; Vents",
  "Plumbing",
  "Family Intelligence System",
  "Installation Service",
  "Timber",
  "Boards",
  "Plastic Building Materials",
  "Earthwork Products",
  "Curtain Walls &amp; Accessories",
  "Garden Landscaping &amp; Decking",
  "Ceilings",
  "Sunrooms &amp; Glass Houses",
  "Doors, Gates &amp; Windows",
  "Stairs &amp; Stair Parts",
  "Tiles &amp; Accessories",
  "Flooring &amp; Accessories",
  "Home &amp; Garden",
  "Garden Supplies",
  "Home Textile",
  "Home Storage &amp; Organization",
  "Household Merchandises",
  "Kitchen,Dining &amp; Bar",
  "Home Decor",
  "Collectibles",
  "Arts,Crafts &amp; Sewing",
  "Festive &amp; Party Supplies",
  "Pet Products",
  "Sports &amp; Entertainment",
  "Sports Competitions",
  "Racquet Sports",
  "Entertainment",
  "Skiing &amp; Snowboarding",
  "Roller,Skateboard",
  "Cycling",
  "Team Sports",
  "Other Sports &amp; Entertainment Product",
  "Sports Bags(hidden)",
  "Water Sports",
  "Shooting",
  "Hunting",
  "Fishing",
  "Horse Riding",
  "Camping &amp; Hiking",
  "Musical Instruments",
  "Fitness &amp; Body Building",
  "Golf",
  "Cheerleading",
  "Office &amp; School Supplies",
  "Pens, Pencils &amp; Writing Supplies",
  "Printing Products",
  "Paper &amp; Printable Media",
  "Drafting Supplies",
  "Books（old）",
  "Maps &amp; Atlases",
  "Journal, Periodical &amp; Magazines",
  "Stationery Sticker",
  "Mailing &amp; Shipping",
  "Filing Products",
  "Notebooks &amp; Writing Pads",
  "School Supplies",
  "Tapes, Adhesives &amp; Fasteners",
  "Educational Equipment &amp; Supplies",
  "Office Binding Supplies",
  "Art Tool Kits",
  "Books",
  "Desk Accessories &amp; Organizer",
  "Art Supplies",
  "Presentation Supplies",
  "Accounting Supplies",
  "Toys &amp; Hobbies",
  "Games and Puzzles",
  "Dolls &amp; Stuffed Toys",
  "Stress Relief Toy",
  "Electronic Toys",
  "Stuffed Animals &amp; Plush",
  "Remote Control Toys",
  "Dolls &amp; Accessories",
  "Building &amp; Construction Toys",
  "Play Vehicles &amp; Models",
  "Outdoor Fun &amp; Sports",
  "Learning &amp; Education",
  "Pretend Play",
  "Classic Toys",
  "Baby &amp; Toddler Toys",
  "Hobby &amp; Collectibles",
  "High Tech Toys",
  "Action &amp; Toy Figures",
  "Arts &amp; Crafts, DIY toys",
  "Pools &amp; Water Fun",
  "Kid's Party",
  "Security &amp; Protection",
  "IoT Devices",
  "First Aid Kits",
  "Building Automation",
  "Disaster-relief Supplies",
  "Public Broadcasting",
  "Safes",
  "Workplace Safety Supplies",
  "Fire Protection",
  "Video Surveillance",
  "Roadway Safety",
  "Access Control",
  "Security Inspection Device",
  "Self Defense Supplies",
  "UAV System &amp; Robot",
  "Transmission &amp; Cables",
  "Security Alarm",
  "Intercom",
  "Smart Card System",
  "Automobiles, Parts &amp; Accessories",
  "Car Lights",
  "Chassis Parts",
  "Exterior Accessories",
  "Engines &amp; Engine Parts",
  "Interior Accessories",
  "Electrical Equipment",
  "Wear Parts",
  "Exterior Parts",
  "Car Electronics",
  "Auto Replacement Parts",
  "Car Lock System",
  "New Energy Vehicle Parts &amp; Accessories",
  "Automotive Sensors",
  "Car Services",
  "Auto Sale",
  "Other Vehicle Parts &amp; Accessories",
  "Interior Parts",
  "Car Wash &amp; Maintenance",
  "Car Repair Tool",
  "Jewelry &amp; Accessories",
  "Fine Jewelry",
  "Fashion Jewelry",
  "Jewelry Packaging &amp; Display",
  "Jewelry Tools &amp; Equipments",
  "Customized Jewelry",
  "Smart Jewelry",
  "Jewelry Making",
  "Lights &amp; Lighting",
  "Lighting Accessories",
  "Professional Light",
  "Indoor Lighting",
  "Holiday Lighting",
  "Outdoor Lighting",
  "Lighting Bulbs &amp; Tubes",
  "Commercial Lighting",
  "Novelty Lighting",
  "Other Lights &amp; Lighting Products",
  "Night Lights",
  "LED Lighting",
  "Portable Lighting",
  "Special Engineering Lighting",
  "Consumer Electronics",
  "Accessories &amp; Parts",
  "Smart Electronics",
  "Electronic Cigarettes",
  "Games &amp; Accessories",
  "Portable Audio &amp; Video",
  "Camera &amp; Photo",
  "Home Audio &amp; Video",
  "Beauty &amp; Health",
  "Sanitary Paper",
  "Health Care",
  "Bath &amp; Shower",
  "Oral Hygiene",
  "Skin Care",
  "Fragrances &amp; Deodorants",
  "Tools &amp; Accessories",
  "Hair Care &amp; Styling",
  "Nail Art &amp; Tools",
  "Makeup",
  "Shaving &amp; Hair Removal",
  "Beauty Equipment",
  "Dental Supplies",
  "Massage &amp; Relaxation",
  "Skin Care Tool",
  "Weddings &amp; Events",
  "Wedding Party Dress",
  "Special Occasion Dresses",
  "Formal Occasion Dresses",
  "Bespoke Occasion Dresses",
  "Wedding Accessories",
  "Wedding Dresses",
  "Shoes",
  "Women's Shoes",
  "Men's Shoes",
  "Mules &amp; Clogs",
  "Shoe Accessories",
  "Other Shoes",
  "Electronic Components &amp; Supplies",
  "Electronic Data Systems",
  "Electronics Stocks",
  "Electronic Signs",
  "EL Products",
  "Active Components",
  "Electronics Production Machinery",
  "Electronic Accessories &amp; Supplies",
  "Optoelectronic Displays",
  "Passive Components",
  "Other Electronic Components",
  "Phones &amp; Telecommunications",
  "Sim Cards &amp; Accessories",
  "Walkie Talkie Parts &amp; Accessories",
  "Walkie Talkie",
  "Mobile Phone Parts",
  "Mobile Phone Accessories",
  "Communication Equipment",
  "Mobile Phones",
  "Tools",
  "Power Tools",
  "Welding &amp; Soldering Supplies",
  "Abrasives",
  "Woodworking Machinery",
  "Welding Equipment",
  "Measurement &amp; Analysis Instruments",
  "Riveter Guns",
  "Agricultural Machinery &amp; Equipment",
  "Abrasive Tools",
  "Woodworking Machinery Parts",
  "Power Tool Parts &amp; Accessories",
  "Tool Sets",
  "Hand Tools",
  "Tool Parts",
  "Construction Tools",
  "Other Tools",
  "Garden Tools",
  "Machinery &amp; Accessories",
  "Material Handling Tools",
  "Tools Packaging",
  "Saw Blade",
  "Drill Bit",
  "Mother &amp; Kids",
  "Baby Clothing",
  "Children's Clothing",
  "Activity &amp; Gear",
  "Feeding",
  "Safety",
  "Diapering &amp; Toilet Training",
  "Pregnancy &amp; Maternity",
  "Baby Diaper &amp; Wipes",
  "Car Seats &amp; Accessories",
  "Baby Care",
  "Baby Shoes",
  "Children's Shoes",
  "Maternity Clothings",
  "Baby&nbsp;Sterilization &amp; Appliances",
  "Baby Souvenirs",
  "Baby Furniture",
  "Baby Food",
  "Baby Strollers&amp;Accessories",
  "Bedding",
  "Kids Accessories",
  "Furniture",
  "Home Furniture",
  "Office Furniture",
  "Commercial Furniture",
  "Outdoor Furniture",
  "Other Furniture",
  "Furniture Parts",
  "Furniture Accessories",
  "Bar Furniture",
  "Children Furniture",
  "Café Furniture",
  "Watches",
  "Men's Watches",
  "Women's Watches",
  "Children's Watches",
  "Couple Watches",
  "Watches Accessories",
  "Pocket &amp; Fob Watches",
  "Luggage &amp; Bags",
  "Summer Bags",
  "Travel Accessories",
  "Winter Bags",
  "Kids' Bags",
  "Travel Bags",
  "School Bags",
  "Wallets &amp; Holders",
  "Special Purpose Bags",
  "Leisure Bags",
  "Luggage &amp; Travel Bags",
  "Backpacks",
  "Briefcases",
  "Bag Parts &amp; Accessories",
  "Other Luggage &amp; Bags",
  "Luggage",
  "Waist Packs",
  "Women's Handbags",
  "Men's Bags",
  "Chest Bags",
  "Skirts",
  "Swimwears",
  "Parkas",
  "Blazer &amp; Suits",
  "Fur &amp; Faux Fur",
  "Faux Leather",
  "Women's Sets",
  "Ready-to-wear Dresses",
  "Jumpsuits, Playsuits &amp; Bodysuits",
  "Jeans",
  "Shorts",
  "Pants &amp; Capris",
  "Sweaters",
  "Hoodies &amp; Sweatshirts",
  "Dresses",
  "Blouses &amp; Shirts",
  "Leggings",
  "Tops &amp; Tees",
  "Coats &amp; Jackets",
  "Matching Sets",
  "Real Fur",
  "Shirts &amp; Blouses",
  "Plus Size Clothes",
  "Muslim Fashion",
  "Genuine Leather",
  "Sweaters&amp;Jumpers",
  "Jumpsuits&amp;Rompers",
  "Down Coats",
  "Men's Clothing",
  "Shirts",
  "Swimwears",
  "Parkas",
  "Suits &amp; Blazer",
  "Men's Sets",
  "Jeans",
  "Hoodies &amp; Sweatshirts",
  "Tops &amp; Tees",
  "Coats &amp; Jackets",
  "Shorts",
  "Sweaters",
  "Muslim Fashion",
  "Pants",
  "Down Coats",
  "Apparel Accessories",
  "Collar Stays",
  "Scarf, Hat &amp; Glove Sets",
  "Eyewear &amp; Accessories",
  "Headwear",
  "Gloves &amp; Mittens",
  "Earmuffs",
  "Handkerchiefs",
  "Scarves &amp; Wraps",
  "Arm Warmers",
  "Hats &amp; Caps",
  "Belts",
  "Cummerbunds",
  "Ties",
  "Mask",
  "Knee Sleeve",
  "Suspenders",
  "Apparel Fabrics &amp; Textiles",
  "Belt Buckle",
  "new Scarf &amp;Wrap",
  "Arm Warmer",
  "New Headwear",
  "Pocket Squares",
  "Fashionable Canes",
  "DIY Accessories",
  "Hair Extensions &amp; Wigs",
  "Human Hair (For White)",
  "Synthetic Hair",
  "Synthetic Hair(For White)",
  "Beauty Supply",
  "Human Hair (For Black)",
  "Human Wigs( For Black)",
  "Hair Salon Supply",
  "Hair Tools &amp; Accessories",
  "Special Category",
  "Down payment/ Purchasing Agent",
  "Other",
  "Upcoming Products",
  "Giveaways",
  "Custom-made Charge",
  "Additional Pay on Your Order",
  "Checkout Link",
  "Prepaid Digital Codes",
  "Giftcard",
  "Beginner for XinXiaoYuan",
  "Mobile Phone Recharge",
  "Overseas Warehouse",
  "Platform Coupon",
  "Wallpaper Sample",
  "Lottery Tickets（Without VAT）",
  "Mini App",
  "Event Ticket",
  "Giftcard1",
  "Software &amp;Games (without VAT)",
  "Custom-made-Charge",
  "Women's Sleep &amp; Lounge",
  "Men's Sleep &amp; Lounge",
  "Men's Socks",
  "Women's Socks &amp; Hosiery",
  "Work Wear &amp; Uniforms",
  "World Apparel",
  "Costumes &amp; Accessories",
  "Functional Apparel",
  "Stage &amp; Dance Wear",
  "Virtual Products",
  "Software &amp; Games",
  "Mobile Phone Recharge",
  "Offline Activity For New Seller",
  "Topup Commission Category",
  "Mobile Phone Recharge1111",
  "Giftcard",
  "Prepaid Digital Codes",
  "Giftcard Commission Category",
  "Coupons",
  "Event Ticket",
  "Dance",
  "Sneakers",
  "Sport Bags",
  "Second-Hand",
  "Used Phones",
  "Motorcycle Equipments &amp; Parts",
  "Boats",
  "Motorcycle Parts",
  "Motorcycle &amp; ATV",
  "Motorcycle Equipments",
  "Motorcycle Accessories",
  "Ornamental &amp; Cleaning &amp; Protection",
  "Aircraft",
];

// sharesale get data
export const fetchData = async (filename) => {
  if (filename === undefined) {
    return null;
  }
  const response = await fetch(process.env.PUBLIC_URL + filename);
  const text = await response?.text();
  const lines = text?.trim()?.split("\n");
  const headers = lines?.[0]?.split("|");
  const data = lines?.slice(1).map((line) => line?.split("|"));
  const formattedData = data?.map((line) => {
    const row = {};
    headers?.forEach((header, i) => {
      row[header] = line?.[i];
    });
    return row;
  });
  return formattedData;
};

export const fetchDataPaginated = async (filename) => {
  if (filename === undefined) {
    return null;
  }
  const response = await fetch(process.env.PUBLIC_URL + filename);
  const text = await response?.text();
  const lines = text?.trim()?.split("\n");
  const headers = lines?.[0]?.split("|");
  const data = lines?.slice(1).map((line) => line?.split("|"));
  const formattedData = data?.map((line) => {
    const row = {};
    headers?.forEach((header, i) => {
      row[header] = line?.[i];
    });
    return row;
  });
  return formattedData;
};

export const getFilesByParam = (param) => {
  let files = [];

  const data = {
    filename: `${param.toLocaleLowerCase()}-data.txt`,
    title: "Products:",
    logo: "",
    name: param.toLocaleLowerCase(),
    preferredHeight: "1080",
    preferredWidth: "1080",
    website: "",
    theme: "dark",
    bgColor: "rgb(251, 81, 42)",
  };

  if (param.toLocaleLowerCase() === "jackery") {
    files.push({
      ...data,
      preferredWidth: "300",
      preferredHeight: "250",
      fileType: "datafeed",
      merchantId: "97366",
      isShareUrl: true,
      link: "https://shrsl.com/415z9",
      videoUrl: "https://shrslv.s3.amazonaws.com/97366/ProductSpecs30-Sec.mp4",
      couponLogo: "/local/jackeryLogo.svg",
      couponBgColor: "rgb(251, 81, 42)",
      couponTheme: "dark",
    });
  } else if (param.toLocaleLowerCase() === "maven") {
    files.push({
      ...data,
      preferredWidth: "300",
      preferredHeight: "250",
      fileType: "datafeed",
      merchantId: "94945",
      isShareUrl: true,
      link: "https://shrsl.com/415ut",
      videoUrl: "https://shrslv.s3.amazonaws.com/94945/mavensafetyshoes.mp4",
      couponLogo:
        "https://static.shareasale.com/image/94945/marketing/140168_0.png",
      couponBgColor: "#fff",
      couponTheme: "light",
    });
  } 
  // else if (param.toLocaleLowerCase() === "dresslily") {
  //   files.push({
  //     ...data,
  //     preferredWidth: "300",
  //     preferredHeight: "250",
  //     fileType: "datafeed",
  //     merchantId: "56695",
  //     isShareUrl: true,
  //     link: "https://shrsl.com/4160v",
  //     videoUrl: "",
  //     couponLogo:
  //       "https://static.shareasale.com/image/56695/marketing/11087_0.jpg",
  //     couponBgColor: "",
  //     couponTheme: "light",
  //   });
  // }
  // else if (param.toLocaleLowerCase() === "rosewe") {
  //   files.push({
  //     ...data,
  //     preferredWidth: "300",
  //     preferredHeight: "250",
  //     fileType: "datafeed",
  //     merchantId: "98211",
  //     isShareUrl: true,
  //     link: "https://shrsl.com/41awn",
  //     videoUrl: "",
  //     couponLogo:
  //       "https://static.shareasale.com/image/98211/marketing/85536_0.jpg",
  //     couponBgColor: "",
  //     couponTheme: "light",
  //   });
  // }
  else if (param.toLocaleLowerCase() === "evebands") {
    files.push({
      ...data,
      bgColor: "rgb(251, 81, 42)",
      fileType: "normal",
      isShareUrl: true,
      link: "https://shrsl.com/41613",
      videoUrl: "",
      couponLogo:
        "https://cdn.shopify.com/s/files/1/0573/5091/4229/files/eb-logo_120x.png?v=1664052292",
      couponBgColor: "#fff",
      couponTheme: "light",
    });
  } else if (param.toLocaleLowerCase() === "goldia") {
    files.push({
      ...data,
      fileType: "datafeed",
      merchantId: "5903",
      isShareUrl: false,
      link: "https://shrsl.com/41611",
      videoUrl: "",
      couponLogo:
        "//cdn.shopify.com/s/files/1/0438/9809/files/logo_2_d0a5d074-f460-4da5-803c-3481b46449b4.jpg?v=1676637888&width=50 50w, //cdn.shopify.com/s/files/1/0438/9809/files/logo_2_d0a5d074-f460-4da5-803c-3481b46449b4.jpg?v=1676637888&width=100 100w, //cdn.shopify.com/s/files/1/0438/9809/files/logo_2_d0a5d074-f460-4da5-803c-3481b46449b4.jpg?v=1676637888&width=150 150w, //cdn.shopify.com/s/files/1/0438/9809/files/logo_2_d0a5d074-f460-4da5-803c-3481b46449b4.jpg?v=1676637888&width=200 200w, //cdn.shopify.com/s/files/1/0438/9809/files/logo_2_d0a5d074-f460-4da5-803c-3481b46449b4.jpg?v=1676637888&width=250 250w, //cdn.shopify.com/s/files/1/0438/9809/files/logo_2_d0a5d074-f460-4da5-803c-3481b46449b4.jpg?v=1676637888&width=300 300w",
      couponBgColor: "#C5932A",
      couponTheme: "dark",
    });
  } else if (param.toLocaleLowerCase() === "auxbeam") {
    files.push({
      ...data,
      preferredWidth: "300",
      preferredHeight: "250",
      fileType: "datafeed",
      merchantId: "67515",
      isShareUrl: true,
      link: "https://shrsl.com/415xl",
      videoUrl: "https://shrslv.s3.amazonaws.com/67515/lv_0_20210908164247.mp4",
      couponLogo:
        "https://static.shareasale.com/image/67515/marketing/41993_0.jpg",
      couponBgColor: "#ffffff",
      couponTheme: "light",
    });
  } else if (param.toLocaleLowerCase() === "overhalfsale") {
    files.push({
      ...data,
      preferredWidth: "300",
      preferredHeight: "250",
      fileType: "datafeed",
      merchantId: "25790",
      isShareUrl: true,
      link: "https://shrsl.com/415z8",
      videoUrl: "",
      couponLogo:
        "https://static.shareasale.com/image/25790/marketing/128770_0.png",
      couponBgColor: "",
      couponTheme: "light",
    });
  } else if (param.toLocaleLowerCase() === "monspeakix") {
    files.push({
      ...data,
      preferredWidth: "300",
      preferredHeight: "250",
      fileType: "datafeed",
      merchantId: "71754",
      isShareUrl: true,
      link: "https://shrsl.com/44qet",
      videoUrl: "",
      couponLogo:
        "https://cdn.shopify.com/s/files/1/1373/7403/files/mons-peak-ix-light-logo_3b28e499-e6a1-4403-b7c5-32c2282eaf8d_200x.png?v=1613153190",
      couponBgColor: "",
      couponTheme: "light",
    });
  } else if (param.toLocaleLowerCase() === "sense-u") {
    files.push({
      ...data,
      preferredWidth: "300",
      preferredHeight: "250",
      fileType: "datafeed",
      merchantId: "102134",
      isShareUrl: true,
      link: "https://shrsl.com/415zb",
      videoUrl:
        "https://shrslv.s3.amazonaws.com/102134/Sense-UBabyMonitor2_1.mp4",
      couponLogo:
        "//cdn.shopify.com/s/files/1/0067/8916/9255/files/Sense-U_Icon_300x300_4805b714-3658-45c3-af28-66d6535e76cd.jpg?height=60&v=1650681393",
      couponBgColor: "#ffffff",
      couponTheme: "light",
    });
  } else if (param.toLocaleLowerCase() === "bulkbeefjerky") {
    files.push({
      ...data,
      preferredWidth: "300",
      preferredHeight: "250",
      fileType: "datafeed",
      merchantId: "137513",
      isShareUrl: true,
      link: "https://shrsl.com/4177l",
      videoUrl: "",
      couponLogo:
        "https://cdn.shopify.com/s/files/1/0429/9385/files/logo-2_4_100x.png?v=1664606319",
      couponBgColor: "#ffffff",
      couponTheme: "light",
    });
  }

  return files;
};
